import "./TagGroup.scss";

export type TagGroupProps = {} & React.HTMLAttributes<HTMLDivElement>;

export const TagGroup: React.FC<TagGroupProps> = ({ children }) => {
  return <div className="tag-group">{children}</div>;
};
